import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { process } from '../../constants/env';

export const grp = process.env.REACT_APP_GRP ?? '';

export interface AuthState {
  grp: string;
  autologin: boolean;
  token: string;
  username: string;
  password: string;
  role: string;
  roleObj: unknown | null;
  status: 'idle' | 'loading' | 'failed' | string;
  btcTv?: unknown;
}

interface FetchTokenSuccess {
  username: string;
  password: string;
  token: string;
  role: string;
  roleObj?: unknown | null;
}

const initialState: AuthState = {
  grp,
  autologin: false,
  token: '',
  username: '',
  password: '',
  role: '',
  roleObj: null,
  status: 'idle',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<FetchTokenSuccess>) => {
      state.username = action.payload.username;
      state.token = action.payload.token;
      state.role = action.payload.role;
      state.roleObj = action.payload.roleObj ?? null;
    },
    logout: (state) => {
      state.username = '';
      state.token = '';
      state.role = '';
      state.roleObj = null;
      localStorage.removeItem('token');
    },
    setAutologin: (state, action: PayloadAction<{ autologin: boolean }>) => {
      state.autologin = action.payload.autologin;
    },
    setRoleObj: (state, action: PayloadAction<{ roleObj: unknown | null }>) => {
      state.roleObj = action.payload.roleObj;
    },
    setBtcTv: (state, action: PayloadAction<{ btcTv: unknown }>) => {
      state.btcTv = action.payload.btcTv;
    },
    setGrp: (state, action: PayloadAction<{ grp: string }>) => {
      state.grp = action.payload.grp;
    },
  },
});

export const { login, logout, setRoleObj, setBtcTv, setAutologin, setGrp } = authSlice.actions;
export const selectToken = (state: { auth: AuthState }) => state.auth.token;
export const selectUsername = (state: { auth: AuthState }) => state.auth.username;
export const selectAutologin = (state: { auth: AuthState }) => state.auth.autologin;
export const selectRoleObj = (state: { auth: AuthState }) => state.auth.roleObj;
export const selectBtcTv = (state: { auth: AuthState }) => state.auth.btcTv;
export const selectGrp = (state: { auth: AuthState }) => state.auth.grp;
export default authSlice.reducer;
